module.exports = __webpack_public_path__ + "img/2024-02-13b_1.829de142.jpg";